import { useQuery } from '@tanstack/react-query';

import { qrcodeAPIService } from '~/api/qrcode';
import { qrCodeStylesKeys } from '~/constants/queryKeys';

export default function useQrCodeStylesData() {
  return useQuery({
    queryKey: qrCodeStylesKeys.qrCodeStyles,
    queryFn: qrcodeAPIService.getQrCodeStyles,
    select: (res) => res.data,
  });
}
